<footer class="footer">
  <div class="inner">
    <div class="custom-note">{{ note }}</div>
    <ul class="list">
      <li class="item">
        <span><img src="assets/map.svg" alt="" />位置 |</span>
        <span>新北市三重區</span>
      </li>
      <li class="item">
        <span><img src="assets/phone.svg" alt="" />電話 |</span>
        <span>09XX-XXX-XXX</span>
      </li>
      <li class="item">
        <span><img src="assets/clock.svg" alt="" />時間 |</span>
        <span>星期一 ~ 五、8:00 ~ 17:30</span>
      </li>
    </ul>
  </div>
  <img class="line" src="assets/footer-line.png" alt="" />
  <small class="copyright"
    >Copyright ©2024 - 強尼貓咪認養平台 All Rights Reserved. Design by
    JwStudio/JwNet studio</small
  >
</footer>
